import $ from 'jquery';
import axios from 'axios';
import toastr from "toastr";
import * as bootstrap from 'bootstrap';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.$ = window.jQuery = $;
window.bootstrap = bootstrap;
window.Pusher = Pusher;

window.toastr = toastr;

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Configure Laravel Echo for WebSocket connections (Laravel Mix build)
// Uses process.env.MIX_ prefix for Laravel Mix (Webpack) compatibility
if (process.env.MIX_REVERB_APP_KEY) {
    window.Echo = new Echo({
        broadcaster: 'reverb',
        key: process.env.MIX_REVERB_APP_KEY,
        wsHost: process.env.MIX_REVERB_HOST,
        wsPort: process.env.MIX_REVERB_PORT ?? 80,
        wssPort: process.env.MIX_REVERB_PORT ?? 443,
        forceTLS: (process.env.MIX_REVERB_SCHEME ?? 'https') === 'https',
        enabledTransports: ['ws', 'wss'],
        authEndpoint: '/broadcasting/auth',
        auth: {
            headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/json'
            }
        }
    });

    console.log('[Echo] Configured with Reverb:', {
        host: process.env.MIX_REVERB_HOST,
        port: process.env.MIX_REVERB_PORT,
        scheme: process.env.MIX_REVERB_SCHEME,
        authEndpoint: '/broadcasting/auth'
    });
} else {
    // WebSocket not configured - Echo will not be available
    console.warn('[Echo] Reverb configuration missing - WebSocket connections will not be available');
    window.Echo = null;
}

toastr.options = {
    "closeButton": true,
    "positionClass": "toast-top-center",
    "timeOut": "2000"
}

// Bootstrap.js loaded without select2 to prevent form conflicts
$(document).ready(function() {
    // Bootstrap loaded - no select2 conflicts
});
